import { GenericTableHead } from 'dashboard409a/components/ValuationsTable/common';
import { ModelsTableHeadProps } from '../ModelsTable.types';

const ModelsTableHead = ({
  order,
  orderBy,
  onRequestSort,
  columns,
}: ModelsTableHeadProps) => (
  <GenericTableHead
    order={order}
    orderBy={orderBy}
    onRequestSort={onRequestSort}
    columns={columns}
  />
);

export default ModelsTableHead;
